// Action types for performance tests
export const SET_TESTS_LOADING = "performance_tests/SET_TESTS_LOADING";
export const SET_TESTS_LIST = "performance_tests/SET_TESTS_LIST";
export const SET_TESTS_ERROR = "performance_tests/SET_TESTS_ERROR";

export const SET_TEST_DETAILS_LOADING =
  "performance_tests/SET_TEST_DETAILS_LOADING";
export const SET_TEST_DETAILS = "performance_tests/SET_TEST_DETAILS";
export const SET_TEST_DETAILS_ERROR =
  "performance_tests/SET_TEST_DETAILS_ERROR";
export const RESET_TEST_DETAILS = "performance_tests/RESET_TEST_DETAILS";

export const SET_REPORTS_LOADING = "performance_tests/SET_REPORTS_LOADING";
export const SET_REPORTS_LIST = "performance_tests/SET_REPORTS_LIST";
export const SET_REPORTS_ERROR = "performance_tests/SET_REPORTS_ERROR";

export const SET_LATEST_REPORT_LOADING =
  "performance_tests/SET_LATEST_REPORT_LOADING";
export const SET_LATEST_REPORT = "performance_tests/SET_LATEST_REPORT";
export const SET_LATEST_REPORT_ERROR =
  "performance_tests/SET_LATEST_REPORT_ERROR";
export const RESET_LATEST_REPORT = "performance_tests/RESET_LATEST_REPORT";

// Performance tests container route
export const PERFORMANCE_TESTS_ROUTE = "/performance-tests";
